/* ==========================================================================

 Tooltip

 Author:      Chris Sheppard (http://www.chrissheppard.co.uk)
 Description: Creates a basic tooltip.

 Simply add the class u-Tooltip to an element and give it a title attribute
 and a tooltip will be created.

 Uses the jQuery tooltip plugin from http://darsa.in/tooltip/

 ========================================================================== */
'use strict';

var Backbone = require('backbone'),
  Tooltip = Backbone.View.extend({
    initialize: function(options) {
      this.$el.tooltipster(options);
      this.tooltipster = this.getTooltipsterInstance();
    },

    getTooltipsterInstance: function() {
      var ns = this.$el.data('tooltipster-ns');
      return this.$el.data(ns[ns.length - 1]);
    },

    open: function(cb) {
      this.tooltipster.show(cb);
    },

    close: function(cb) {
      this.tooltipster.hide(cb);
    },

    rePosition: function() {
      this.tooltipster.reposition();
    }

  }, {
    create: function($parent) {
      $parent.find('.u-Tooltip').each(function(n, el) {
        new Tooltip({
          el: el,
          side: 'top',
          theme: 'Tooltip'
        });
      });
    }
  });

module.exports = Tooltip;



// WEBPACK FOOTER //
// ./assets/js/components/Tooltip.js